// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1XA2R","footer":"ModalFilter_footer__24QiI"};